import type { ActivePack, PackHistoryItem } from '../services/api/types';
import type { ScooterPack } from '../services/api/scooterPackService';

type ActivatedPack = ActivePack | ScooterPack;

export interface ManualPackActivationDeps {
  activateEnergyPack: (packId: string) => Promise<ActivePack>;
  activateScooterPack: (packId: string) => Promise<ScooterPack>;
  invalidateReadiness: (vin?: string) => void;
}

export const canManuallyActivatePack = (
  pack: Pick<PackHistoryItem, 'status_group'>,
  hasActivePackOfSameKind: boolean,
): boolean => pack.status_group === 'queued' && !hasActivePackOfSameKind;

export async function activateQueuedPack(
  pack: Pick<PackHistoryItem, 'kind' | 'pack_id' | 'scooter_vin'>,
  deps: ManualPackActivationDeps,
): Promise<ActivatedPack> {
  const activatedPack = pack.kind === 'energy'
    ? await deps.activateEnergyPack(pack.pack_id)
    : await deps.activateScooterPack(pack.pack_id);

  deps.invalidateReadiness(activatedPack.scooter_vin || pack.scooter_vin);
  return activatedPack;
}
